import React, { Component } from 'react';
import ContentLayoutPageComponent from '../Layout/ContentLayout'

class Layout extends Component {
  render() {
    return <ContentLayoutPageComponent />
  } 
}

export default Layout;